import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/app/components/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/components/ImageComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/app/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.5.4_@babel+core@7.28.4_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/next/dist/client/app-dir/link.js");
